/* 
export default (value) => {
  const validRegexp = /^[1-9][0-9]*(?:[\.]\d{0,2})?$/
  return validRegexp.test(value)
} */

export const validName = /^[a-zA-Z\s]+$/
